<div class="container flex-1 d-flex fd-col jc-center ai-center">
  <div class="text-container d-flex fd-col jc-center ai-center">
    <span class="title">
      This dashboard requires a subscription that you do not have.
    </span>

    <div>
      <span class="data-source">
        {{ dataSource | titlecase }}
      </span>
    </div>

    <a class="link" routerLink="/private/my-account/subscription">
      My Subscriptions
    </a>
  </div>
</div>
